import { ReactElement, useState } from 'react';
import { App, Button, Upload } from 'antd';
import type { UploadFile } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { formatDate } from '../../../shared/utils/dateFormatter';
import { SectionCard, CardTitle, LastUploadedText, UploadHint, UploadFooter } from './styles';

// MOCK [#239]: 本番実装時はバックエンドが返す最終アップロード日時（S3オブジェクトの LastModified）に
// 置き換える。未アップロードなら null。
const getLastUploadedAt = (): Date | null => new Date('2026-08-20T14:32:00');

const GStaffUpload = (): ReactElement => {
  const { message } = App.useApp();
  const lastUploadedAt = getLastUploadedAt();
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const hasFile = fileList.length > 0;

  const handleSubmit = (): void => {
    // MOCK [#239]: 本番実装時はファイルをバックエンドへ送信し、サーバー側で変換・検証した結果
    // （取込件数・エラー行）を表示してから反映する。
    void message.info('（モック）アップロード処理は未実装です');
  };

  return (
    <SectionCard>
      <CardTitle>Gスタッフ稼働歴</CardTitle>
      <LastUploadedText>
        最終アップロード: {lastUploadedAt === null ? '未アップロード' : formatDate(lastUploadedAt)}
      </LastUploadedText>
      <UploadHint>
        Gスタッフからエクスポートした稼働歴ファイル（Excel / CSV）をアップロードして最新版に更新します。
      </UploadHint>
      <Upload
        accept='.xlsx,.csv'
        maxCount={1}
        beforeUpload={() => false}
        fileList={fileList}
        onChange={info => {
          setFileList(info.fileList);
        }}
      >
        <Button icon={<UploadOutlined />}>ファイルを選択</Button>
      </Upload>
      <UploadFooter>
        <Button type='primary' onClick={handleSubmit} disabled={!hasFile}>
          アップロードして反映
        </Button>
      </UploadFooter>
    </SectionCard>
  );
};

export default GStaffUpload;
